"use strict";

exports.__esModule = true;
exports.SCHEDULING_SETTINGS_KEY = 'SCHEDULING_SETTINGS_KEY', exports.SCREEN_CAPTURE_SETTINGS_KEY = 'SCREEN_CAPTURE_SETTINGS_KEY', exports.CREATE_DATA_REPORT_SETTINGS_KEY = 'CREATE_DATA_REPORT_SETTINGS_KEY', exports.USER_DETAILS_KEY = 'USER_DETAILS_KEY', exports.HELP_CONTEXT_KEY_VALUE_STORE_KEY = 'HELP_CONTEXT_KEY_VALUE_STORE_KEY';